import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Calculator, FileSpreadsheet, Users, Briefcase } from 'lucide-react';
import WhatsAppButton from '@/components/ui/WhatsAppButton';

const CONTABILIDADE_MESSAGE =
  'Olá, acabei de acessar o site de vocês e gostaria de saber sobre o serviço de Contabilidade';

const benefits = [
  {
    icon: Calculator,
    title: 'BPO Contábil',
    description:
      'Escrituração contábil completa, balancetes e demonstrativos prontos para tomada de decisão.',
  },
  {
    icon: FileSpreadsheet,
    title: 'Gestão Fiscal',
    description:
      'Apuração de impostos, entrega de obrigações acessórias e acompanhamento do regime tributário ideal.',
  },
  {
    icon: Users,
    title: 'Departamento Pessoal',
    description:
      'Folha de pagamento, admissões, férias e rescisões da sua clínica ou consultório sem dor de cabeça.',
  },
  {
    icon: Briefcase,
    title: 'Consultoria Tributária',
    description:
      'Planejamento contínuo focado em saúde, identificando oportunidades legais de economia.',
  },
];

const ContabilidadeSection: React.FC = () => {
  return (
    <section
      id="contabilidade"
      aria-labelledby="contabilidade-heading"
      className="py-12 md:py-20 px-4 md:px-6 bg-gradient-to-b from-background to-accent/30 scroll-mt-24 md:scroll-mt-28"
    >
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-8 md:mb-12 max-w-3xl mx-auto">
          <p className="text-xs tracking-widest font-medium uppercase text-primary mb-2">
            Contabilidade especializada
          </p>
          <h2
            id="contabilidade-heading"
            className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4"
          >
            Contabilidade para profissionais da saúde
          </h2>
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
            Mais do que escrituração: uma equipe que entende a rotina de médicos, clínicas,
            laboratórios e hospitais e cuida da contabilidade enquanto você cuida dos pacientes.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-8 md:mb-12">
          {benefits.map(({ icon: Icon, title, description }) => (
            <Card key={title} className="h-full shadow-sm hover:shadow-md transition-shadow">
              <CardContent className="p-5 md:p-6 flex flex-col items-start gap-3">
                <div className="rounded-lg bg-primary/10 text-primary p-3" aria-hidden="true">
                  <Icon className="h-6 w-6" />
                </div>
                <h3 className="text-lg font-semibold text-foreground">{title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{description}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="flex flex-col items-center text-center gap-3">
          <p className="text-sm md:text-base text-muted-foreground max-w-2xl">
            Quer saber como nossa contabilidade pode simplificar a gestão da sua clínica?
            Fale com um especialista agora mesmo.
          </p>
          <WhatsAppButton
            text="Quero saber sobre Contabilidade"
            source="contabilidade_section"
            customMessage={CONTABILIDADE_MESSAGE}
            size="lg"
            className="min-h-[48px] w-full sm:w-auto"
          />
        </div>
      </div>
    </section>
  );
};

export default ContabilidadeSection;
